import React from 'react';

import {isNil, get} from 'lodash-es';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

const propTypes = {
  heapInitializeValue: PropTypes.number,
};

/**
 * Heap Tracking - Initializes heap tracking by identifying user id
 */
class HeapTracking extends React.Component {
  initializeHeap = () => {
    try {
      const {heapInitializeValue} = this.props;
      window.heap.identify(heapInitializeValue);
    } catch (error) {
      // Ignore complaints about being tracked.
    }
  }

  render() {
    const {heapInitializeValue} = this.props;
    if (!isNil(heapInitializeValue) && window.heap) {
      this.initializeHeap();
    }
    return null;
  }
}

const mapStateToProps = (state) => {
  const user = get(state, 'user', null);
  const heapInitializeValue = get(user, 'id');

  return {
    heapInitializeValue,
  };
};

HeapTracking.propTypes = propTypes;

const HeapTrackingContainer = connect(mapStateToProps, {})(HeapTracking);

export default HeapTrackingContainer;
